import React, { useEffect, useState } from "react";
import {
  Layout, Card, Table, Button, Space, Tag, Typography, Row, Col, Statistic, Tooltip
} from "antd";
import {
  FaPlay, FaStop, FaClock, FaHistory
} from "react-icons/fa";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import api from "../api/Api";

const { Content } = Layout;
const { Title } = Typography;

const Turno = () => {
const [turnoAtual, setTurnoAtual] = useState(null);
const [turnos, setTurnos] = useState([]);
const [loading, setLoading] = useState(false);
  const [loadingAcao, setLoadingAcao] = useState(false); // 👈 loading do botão




  const userStored = JSON.parse(localStorage.getItem("user"));

useEffect(() => {
  document.title = "TURNOS";
  fetchTurnoAtual();
  fetchTurnosUser();
}, []);

  const sms_success = (m) => toast.success(m);
  const sms_error = (m) => toast.error(m);

  // -------------------------------------------------------
  // LISTAR TURNOS
const fetchTurnoAtual = async () => {
  try {
    const resp = await api.ListTurno({ id_user: userStored.id });
    setTurnoAtual(resp); // objeto ou null
  } catch {
    sms_error("Erro ao carregar turno atual");
  }
};

const fetchTurnosUser = async () => {
  try {
    setLoading(true);
    const resp = await api.ListTurnoUser({ id_user: userStored.id });
    setTurnos(resp); // sempre array
  } catch {
    sms_error("Erro ao carregar histórico de turnos");
  } finally {
    setLoading(false);
  }
};



 


  // -------------------------------------------------------
  // TURNO ATUAL
const turnoAberto = turnos.find(
  t => String(t.status).toUpperCase() === "ABERTO"
);



  // -------------------------------------------------------
  // ABRIR TURNO
  const handleAbrirTurno = async () => {
    try {
      setLoadingAcao(true); // 👈
      const resp = await api.AbrirTurno({ id_user: userStored.id });
      if (resp?.success) {
        sms_success("Turno aberto com sucesso!");
        fetchTurnoAtual();
        fetchTurnosUser();
      }
    } catch (error) {
      sms_error("Erro ao abrir turno");
    } finally {
      setLoadingAcao(false); // 👈
    }
  };

  // -------------------------------------------------------
  // FECHAR TURNO
  const handleFecharTurno = async () => {
    try {
      setLoadingAcao(true); // 👈
      const resp = await api.FecharTurno({ id: turnoAberto.id });
      if (resp?.success) {
        sms_success("Turno fechado com sucesso!");
        fetchTurnoAtual();
        fetchTurnosUser();
      }
    } catch (error) {
      sms_error("Erro ao fechar turno");
    } finally {
      setLoadingAcao(false); // 👈
    }
  };

  // -------------------------------------------------------
  // COLUNAS DA TABELA
  const columns = [
    {
      title: "Abertura",
      dataIndex: "abertura",
      render: (t) => new Date(t).toLocaleString()
    },
    {
      title: "Fecho",
      dataIndex: "fecho",
      render: (t) => t ? new Date(t).toLocaleString() : "-"
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (s) =>
        s === "ABERTO"
          ? <Tag color="green">ABERTO</Tag>
          : <Tag color="red">FECHADO</Tag>
    },
    {
      title: "Horas de trabalho",
      dataIndex: "horas_trabalhadas",
      render: (t) => t  
    },
  ];

  return (
    <Layout>
      <Content style={{ padding: 24 }}>
        <ToastContainer />

        <Card
          title={
            <Space>
              <FaClock style={{ fontSize: 22, color: "#1677ff" }} />
              <Title level={4} style={{ margin: 0 }}>
                Gestão de Turno
              </Title>
            </Space>
          }
extra={
  turnoAberto ? (
    <Button
      danger
      icon={<FaStop />}
      onClick={handleFecharTurno}
      loading={loadingAcao}    // 👈
      disabled={loadingAcao}   // 👈
    >
      Fechar Turno
    </Button>
  ) : (
    <Button
      type="primary"
      icon={<FaPlay />}
      onClick={handleAbrirTurno}
      loading={loadingAcao}    // 👈
      disabled={loadingAcao}   // 👈
    >
      Abrir Turno
    </Button>
  )
}

        >
          {/* STATUS ATUAL */}
          <Row gutter={16} style={{ marginBottom: 24 }}>
            <Col span={24}>
              <Card size="small" hoverable>
                <Statistic
                  title="Estado Atual"
                  value={turnoAberto ? "TURNO ABERTO" : "SEM TURNO ABERTO"}
                  prefix={<FaHistory />}
                  valueStyle={{
                    color: turnoAberto ? "green" : "red"
                  }}
                />
              </Card>
            </Col>
          </Row>

          {/* TABELA */}
          <Table
            columns={columns}
            dataSource={turnos}
            rowKey="id"
            loading={loading}
            pagination={{ pageSize: 8 }}
          />
        </Card>
      </Content>
    </Layout>
  );
};

export default Turno;
